import { WebServiceMethod } from './web-method';

export class WebServiceModel {
  method: WebServiceMethod;
  url: string;
  data: any;
  needToken: boolean;
  useFormData: boolean;
  isDataIsJsonType: boolean;
  formData: FormData = new FormData();
  constructor(
    url: string,
    method: WebServiceMethod,
    data?: any,
    needToken: boolean = true,
    useFormData: boolean = false,
    isDataIsJsonType: boolean = true,
  ) {
    this.method = method;
    this.url = url;
    this.data = data;
    this.needToken = needToken;
    this.useFormData = useFormData;
    this.isDataIsJsonType = isDataIsJsonType;
  }

  addFile(key: string, file: any) {
    this.formData.append(key, file);
  }

  addFiles(key: string, files: any[]) {
    for (const file of files) {
      this.formData.append(key, file);
    }
  }
}
